module.exports = __webpack_public_path__ + "snowshoes.svg";